// parallax.js
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but only CommonJS-like environments that support module.exports, like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.Parallax = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  // ...parallax.js code (you can leave it as it was before)...
}));
